import path from 'path'

import { CAD_EXTENSIONS_SET } from '~/lib/cadExtensions'

export default function isCADFile(file) {
    // match against some list of file extensions
    const fileExt = path.extname(file?.name || '').toLowerCase()
    const isCAD = CAD_EXTENSIONS_SET.has(fileExt)

    return isCAD
}
